import * as ResourceApi from 'api/resources';
import * as ServiceApi from 'api/services';

export const publishPrize = id => ServiceApi.performAction(
  ResourceApi.Types.PublishedPrize,
  ServiceApi.Actions.PublishPrize,
  {
    id
  }
);

export const makeWinnerFeatured = (prizeEntryId, lang) => ServiceApi.performAction(
  ResourceApi.Types.PrizeEntry,
  ServiceApi.Actions.MakeFeatured,
  {
    prizeEntryId,
    lang
  }
);

export const makeWinnerUnfeatured = (prizeEntryId, lang) => ServiceApi.performAction(
  ResourceApi.Types.PrizeEntry,
  ServiceApi.Actions.MakeUnfeatured,
  {
    prizeEntryId,
    lang
  }
);

export const publishFeaturedStories = lang => ServiceApi.performAction(
  ResourceApi.Types.PrizeEntry,
  ServiceApi.Actions.PublishFeaturedStories,
  {
    lang
  }
);

export const selectWinners = prizeId => ServiceApi.performAction(
  ResourceApi.Types.Prize,
  ServiceApi.Actions.AwardPrizes,
  {
    prizeId
  }
);

export const addManualEntry = (manualEntry) => ServiceApi.performAction(
    ResourceApi.Types.Prize,
    ServiceApi.Actions.ManualEntry,
    {
        ...manualEntry
    }
);

export const downloadReport = prizeId => ServiceApi.performAction(
  ResourceApi.Types.Prize,
  ServiceApi.Actions.DownloadReport,
  {
    prizeId
  }
);


// WEBPACK FOOTER //
// ./public/api/prize-service.js